import { Box, Typography } from '@mui/material';
import { TextField } from '@components/textField';
import type { FC } from 'react';

interface RenewalDetailsSelectionProps {
  existingPolicyNumber: string;
  onExistingPolicyNumberChange: (v: string) => void;
  renewalTermToBind: string;
  onRenewalTermToBindChange: (v: string) => void;
}

export const RenewalDetailsSelection: FC<RenewalDetailsSelectionProps> = ({
  existingPolicyNumber,
  onExistingPolicyNumberChange,
  renewalTermToBind,
  onRenewalTermToBindChange,
}) => {
  return (
    <Box sx={{ width: '100%', mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant='h5' sx={{ textAlign: 'center' }}>
        Renewal Details
      </Typography>
      <Box sx={{ margin: 'auto', width: { xs: '100%', sm: '300px' } }}>
        <TextField
          inputLabel='Existing Policy Number *'
          value={existingPolicyNumber}
          onChange={(e) => onExistingPolicyNumberChange(e.target.value.replace(/[^0-9]/g, ''))}
          helperLabel='Enter policy number digits only. Prefix is determined by Product Label selection.'
          fullWidth
          config={{
            allowHelperLabelWrap: true,
          }}
        />
        <TextField
          inputLabel='Renewal Term to Bind *'
          value={renewalTermToBind}
          onChange={(e) => onRenewalTermToBindChange(e.target.value.replace(/[^0-9]/g, ''))}
          helperLabel='Renewal term must be a positive integer.'
          fullWidth
        />
      </Box>
    </Box>
  );
};
